import { EnvelopeIcon } from '@heroicons/react/24/outline'
import { FormEvent, useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import { useMutation } from 'urql'
import { requestPasswordResetMutation } from '../../_lib/graphql/mutations'
import { FormField } from '../FormField'
import { PublicLayout } from '../PublicLayout'
import { useSnackbarPush } from '../SnackbarContext/SnackbarContext'

export const PasswordForgotPage = () => {
  const { pushError } = useSnackbarPush()
  const [requestState, executeRequest] = useMutation(requestPasswordResetMutation)
  const [email, setEmail] = useState('')
  const [isRequested, setIsRequested] = useState(false)

  const handleSubmit = useCallback((event: FormEvent) => {
    event.preventDefault()

    executeRequest({ input: { email } }).then(result => {
      if (result.error) {
        pushError(result.error.graphQLErrors[0]?.message || result.error.message)
        return
      }

      setIsRequested(true)
    })
  }, [email, executeRequest, pushError])

  return (
    <PublicLayout>
      <div className={'mx-auto mt-6 max-w-md'}>
        <div className={'rounded-3xl border border-sand-200 bg-white p-6 shadow-sm sm:p-8'}>
          {isRequested ? (
            <div className={'text-center'}>
              <EnvelopeIcon className={'mx-auto h-14 w-14 text-primary'} />
              <h1 className={'mt-4 text-3xl font-bold tracking-tight text-primary-200'}>
                Postfach prüfen
              </h1>
              <p className={'mt-3 text-base leading-7 text-gray-600'}>
                Wenn zu {email} ein Konto existiert, haben wir dir einen Link zum Zurücksetzen des Passworts geschickt.
              </p>
            </div>
          ) : (
            <>
              <h1 className={'text-3xl font-bold tracking-tight text-primary-200 text-balance'}>
                Passwort vergessen?
              </h1>
              <p className={'mt-2 text-sm leading-6 text-gray-600'}>
                Gib deine E-Mail-Adresse ein. Wir schicken dir einen Link, mit dem du ein neues Passwort vergeben kannst.
              </p>
              <form
                onSubmit={handleSubmit}
                className={'mt-6 space-y-5'}
              >
                <FormField
                  id={'email'}
                  label={'E-Mail-Adresse'}
                  type={'email'}
                  autoComplete={'email'}
                  value={email}
                  onChange={setEmail}
                />
                <button
                  type={'submit'}
                  disabled={requestState.fetching}
                  className={'flex w-full justify-center rounded-full bg-primary-200 px-6 py-3 text-sm font-semibold text-white hover:bg-primary-100 disabled:cursor-not-allowed disabled:opacity-60 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'}
                >
                  {requestState.fetching ? 'Wird gesendet …' : 'Link anfordern'}
                </button>
              </form>
            </>
          )}
          <p className={'mt-6 border-t border-sand-200 pt-5 text-sm text-gray-600'}>
            <Link
              to={'/login'}
              className={'font-semibold text-primary hover:underline'}
            >
              Zurück zur Anmeldung
            </Link>
          </p>
        </div>
      </div>
    </PublicLayout>
  )
}
